import { HttpHeaders, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { map, Observable } from 'rxjs';

import { ExportTagType } from '@stylehaven/components';
import { ExportEntity } from '../../entities/downloads/export-entity.entity';
import { ExportJob } from '../../entities/downloads/export-job.entity';
import { QuickExportRequest } from '../../entities/downloads/quick-export-request.entity';
import { RejectionReport, RejectionReportRequest } from '../../entities/downloads/rejection-report-request.entity';
import { MapObjectToHttpParams } from '../../helpers';
import { ApiList } from '../../record/entities/api-list.entity';
import { AbstractHttpService } from '../../services/http/http-service.abstract';
import { toRejectionReport } from '../helpers/rejection-report.helper';

@Injectable()
export class QuickExportService {
    private readonly ENDPOINT: string = 'quick-exports';
    private readonly EXPORTS_ENDPOINT: string = 'exports';
    private readonly REJECTION_REPORT_ENDPOINT: string = 'rejection-reports';

    constructor(private readonly http: AbstractHttpService) {}

    /** The whole response: a 201 carries the created delen, a 202 only the names the delen will get. */
    create(request: QuickExportRequest): Observable<HttpResponse<ExportJob[]>> {
        return this.http.post<HttpResponse<ExportJob[]>>(this.ENDPOINT, request, { observe: 'response' }, 'v2');
    }

    getExport(exportJobId: string): Observable<ExportJob> {
        return this.http.get<ExportJob>(`${this.EXPORTS_ENDPOINT}/${exportJobId}`);
    }

    /** The most recent download exports, to find the delen of a 202 by their name. */
    listRecentExports(nrOfResults: number): Observable<ExportEntity[]> {
        return this.http
            .get<ApiList<ExportEntity>>(
                this.EXPORTS_ENDPOINT,
                MapObjectToHttpParams({ startIndex: 0, nrOfResults, tag: ExportTagType.Download }),
                'v2'
            )
            .pipe(map(apiList => apiList?.Results ?? []));
    }

    getRejectionReport(request: RejectionReportRequest): Observable<RejectionReport> {
        return this.http
            .post<string>(
                this.REJECTION_REPORT_ENDPOINT,
                request,
                { responseType: 'text' as 'json', headers: new HttpHeaders({ Accept: 'text/csv' }) },
                'v2'
            )
            .pipe(map(csv => toRejectionReport(csv)));
    }
}
